import type { ColorName } from '@tomo/core';
import { cx } from '@tomo/ui';
import { Icon } from '../../lib/icons.tsx';

/** Colored rounded square with an icon — projects, collections and page headers. */
export function ProjectTile({ icon, color, size = 30, className }: { icon: string; color: ColorName | string; size?: number; className?: string }) {
  return (
    <span className={cx('project-tile', className)} data-color={color} style={{ ['--tile' as string]: `${size}px` }}>
      <Icon token={icon} size={Math.round(size * 0.52)} />
    </span>
  );
}
